import { axiosInstance } from './index';

/**
 * Huỷ yêu cầu chụp ảnh thêm (追加写真撮影依頼).
 * Viết tay bằng axiosInstance (giống inquiryFeeThread.ts) vì client-axios sinh tự động chưa có endpoint này.
 * BE: POST /storage-process/operation/photo-request/:id/cancel — chỉ khi còn 写真撮影待ち, hoàn 100% 写真追加料.
 */
const BASE = `${process.env.REACT_APP_API_URL}/storage-process`;

export const photoRequestApi = {
  adminCancel: (photoRequestId: number) =>
    axiosInstance.post(`${BASE}/operation/photo-request/${photoRequestId}/cancel`),
};
